// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let JsxRuntime = require("react/jsx-runtime");

function Spinner(props) {
  let __size = props.size;
  let size = __size !== undefined ? __size : 20;
  let sizePx = size.toString() + "px";
  let strokeColor = Stdlib_Option.getOr(props.stroke, "var(--color-silver)");
  return JsxRuntime.jsx("svg", {
    children: JsxRuntime.jsx("circle", {
      className: "animate-tan-spinner-dash",
      cx: "25",
      cy: "25",
      fill: "none",
      r: "20",
      stroke: strokeColor,
      strokeLinecap: "butt",
      strokeWidth: "6"
    }),
    className: "inline-block animate-tan-spinner-rotate",
    height: sizePx,
    width: sizePx,
    viewBox: "0 0 50 50"
  });
}

let make = Spinner;

exports.make = make;
/* react/jsx-runtime Not a pure module */
